import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AllQuestions from '../AllData/AllQuestions';
import './../../pagescss/QuizStarting.css';
import Loading from '../home/Loading';
import Latex from 'react-latex';
import TopNavbar from '../home/TopNavbar';
import TopHeader from '../home/TopHeader';
import { formatTime, getCurrentOptions } from "./quiz/utils/quizUtils";
import { QuizReResults } from "./quiz/components/QuizReResults";
import { QuizReStartScreen } from "./quiz/components/QuizReStartScreen";
import { QuestionNavigation } from "./quiz/components/QuestionNavigation";
import { useQuizHandlers } from "./quiz/hooks/reUseQuizHandlers";
import { FaBars, FaTimes, FaUndo } from "react-icons/fa";
import QuestionImage from './QuestionImage';



function QuizReStarting() {
  const [submissions, setSubmissions] = useState([]);
  const [allanswer, setAllanswer] = useState([]);
  const [questionsId, setQuestionsId] = useState([]);
  const [showContent, setShowContent] = useState(false);


  const { quizId, id } = useParams();
  const phone = "12345";
  const loading = false;
  const questions = AllQuestions;

  // 1. Fetch local submissions data
  useEffect(() => {
    const saved = localStorage.getItem('quizSubmissions');
    const data = saved ? JSON.parse(saved) : [];
    setSubmissions(data);
  }, []);

  // 2. Filter submissions by quizId and aggregate answer objects
  useEffect(() => {
    if (quizId && submissions.length > 0) {
      const filtered = submissions.filter(data => data?.quizId === quizId);
      const allAnswerObjects = filtered.flatMap(submission => submission.answers || []);
      setAllanswer(allAnswerObjects);
    } else {
      setAllanswer([]);
    }
  }, [submissions, quizId]);

  // 3. Extract unique question IDs for the re-test
  useEffect(() => {
    if (allanswer.length > 0) {
      const ids = allanswer
        .map(answer => answer?.questionId)
        .filter(qId => qId != null);
      setQuestionsId([...new Set(ids)]);
    } else {
      setQuestionsId([]);
    }
  }, [allanswer]);


  const handleToggle = () => {
    setShowContent(!showContent);
  };

  // 4. Filter full question details
  const filterQuestions = questionsId.length > 0
    ? questions.filter(q => questionsId.includes(q._id?.$oid || q._id))
    : [];

  const totalQuizTimeInSeconds = filterQuestions.length * 60;
  const [quizStart, setQuizStart] = useState(false);
  const [timeLeft, setTimeLeft] = useState(totalQuizTimeInSeconds);
  const [showSidebar, setShowSidebar] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const currentSubmission = submissions.find(s => s.quizId === quizId);
  const quizName = currentSubmission?.quizName || "Re-Mock Test";



  const {
    selectedAnswers,
    markedQuestions,
    hasSelectedOption,
    currentQuestionIndex,
    isSubmitted,
    score,
    handleOptionChange,
    handleNextQuestion,
    handlePreviousQuestion,
    handleQuestionButtonClick,
    toggleMarkQuestion,
    handleSubmit: originalHandleSubmit,
    handleStartQuiz,
  } = useQuizHandlers(
    filterQuestions,
    phone,
    quizId,
    id,
    quizName,
    totalQuizTimeInSeconds,
    timeLeft
  );

  const executeSubmission = useCallback((autoSubmit = false) => {
    originalHandleSubmit(autoSubmit);


    const updatedAnswers = filterQuestions.map((question, index) => {
      const userSelected = selectedAnswers[index];
      const correctOption = question.correct_option || question.correctAnswer || question.answer;

      return {
        questionId: question._id?.$oid || question._id,
        questionText: question.question,
        userAnswer: userSelected || "notAnswered",
        correctAnswer: correctOption || "notAnswered",
        isCorrect: userSelected === correctOption
      };
    });

    let totalMarks = 0;
    updatedAnswers.forEach(ans => {
      if (ans.isCorrect) totalMarks += 4;
      else if (ans.userAnswer !== "notAnswered") totalMarks -= 1;
    });

    const timeTaken = totalQuizTimeInSeconds - timeLeft;

    const saved = localStorage.getItem('quizSubmissions');
    const existingSubmissions = saved ? JSON.parse(saved) : [];

    const updatedSubmissions = existingSubmissions.map((sub) => {
      if (sub.quizId === quizId) {
        return {
          ...sub,
          answers: updatedAnswers,
          score: totalMarks,
          timeTaken: timeTaken,
          submittedAt: new Date().toLocaleString()
        };
      }
      return sub;
    });



    localStorage.setItem('quizSubmissions', JSON.stringify(updatedSubmissions));
    setSubmissions(updatedSubmissions);

  }, [filterQuestions, selectedAnswers, totalQuizTimeInSeconds, timeLeft, originalHandleSubmit, quizId]);

  const customSubmitHandler = useCallback((isTimeUp = false) => {
    if (!isTimeUp) {
      setShowConfirmModal(true);
      return;
    }
    executeSubmission(true);
  }, [executeSubmission]);

  const handleConfirmSubmit = () => {
    setShowConfirmModal(false);

    executeSubmission(false);
  };

  const handleCancelSubmit = () => {
    setShowConfirmModal(false);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth >= 768) {
        setShowSidebar(true);
      } else {
        setShowSidebar(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (timeLeft > 0 && !isSubmitted && quizStart) {
      const timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);

      return () => clearInterval(timer);
    } else if (timeLeft === 0 && !isSubmitted && quizStart) {
      customSubmitHandler(true);
    }
  }, [timeLeft, isSubmitted, quizStart, customSubmitHandler]);

  {/*
  useEffect(() => {
    if (!quizStart) return;

    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = 'Are you sure you want to leave? Your quiz progress will be lost.';
      return e.returnValue;
    };


    const handlePopState = (e) => {
      if (quizStart) {
        e.preventDefault();
        window.history.pushState(null, '', window.location.href);
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handlePopState);
    };
  }, [quizStart]);
  */}

  const startQuiz = () => {
    handleStartQuiz();
    setQuizStart(true);
    setTimeLeft(totalQuizTimeInSeconds);
    window.history.pushState(null, '', window.location.href);
  };

  const currentQuestion = filterQuestions[currentQuestionIndex];
  const answeredCount = hasSelectedOption.filter(Boolean).length;
  const unansweredCount = filterQuestions.length - answeredCount;
  const markedCount = markedQuestions.filter(Boolean).length;

  const renderWithLatex = (text) => {
    if (!text) return null;
    if (text.includes('$') || text.includes('\\')) {
      return <Latex>{text}</Latex>;
    }
    return text;
  };

  if (loading) {
    return <Loading message="Loading..." />;
  }

  if (filterQuestions.length === 0 && quizStart) {
    return <Loading message="Loading questions..." />;
  }




  return (
    <>


      {quizStart ? (
        <div className="quiz-container">
          {isMobile && (
            <button
              className="mobile-menu-button"
              onClick={() => setShowSidebar(!showSidebar)}
            >
              {showSidebar ? <FaTimes /> : <FaBars />}
            </button>
          )}

          <div className={`quiz-sidebar ${showSidebar ? 'show' : ''}`}>
            <div className="sidebar-content">
              <div className="sidebar-header-quiz">
                <h4>{quizName} Re-Mock Test</h4>
              </div>

              <div className="question-stats">
                <div className="stat-item">
                  <span className="stat-label">Total:</span>
                  <span className="stat-value">{filterQuestions.length}</span>
                </div>
                <div className="stat-item">
                  <span className="stat-label answered">Answered:</span>
                  <span className="stat-value">{answeredCount}</span>
                </div>
                <div className="stat-item">
                  <span className="stat-label unanswered">Unanswered:</span>
                  <span className="stat-value">{unansweredCount}</span>
                </div>
                <div className="stat-item">
                  <span className="stat-label marked">Marked:</span>
                  <span className="stat-value">{markedCount}</span>
                </div>
              </div>

              <div className="question-navigation">
                <QuestionNavigation
                  questions={filterQuestions}
                  hasSelectedOption={hasSelectedOption}
                  currentQuestionIndex={currentQuestionIndex}
                  markedQuestions={markedQuestions}
                  handleQuestionButtonClick={(index) => {
                    handleQuestionButtonClick(index);
                    if (isMobile) setShowSidebar(false);
                  }}
                />
              </div>
            </div>
          </div>

          <div className="quiz-main-content">
            <div className="main-content-inner">
              <div className="quiz-header">
                {!isMobile && <h1>{quizName} Re-Mock Test</h1>}
                {isMobile ? (
                  <div className="timer-mobile">
                    <span>Time Left: </span>
                    <span className="time-value">{formatTime(timeLeft)}</span>
                  </div>
                ) : (
                  <div className="timer">
                    <span>Time Left: </span>
                    <span className="time-value">{formatTime(timeLeft)}</span>
                  </div>
                )}
              </div>

              {!isSubmitted ? (
                <>
                  <div className="question-container">
                    <div className="question-section">
                      <p className="question-number">
                        Question: {currentQuestionIndex + 1} of {filterQuestions.length}
                      </p>
                      {currentQuestion.type === "dpp" || (currentQuestion.type === "previousyearquestions" && currentQuestion.year === "2026") || (currentQuestion.type === "previousyearquestions" && currentQuestion.year === "2025") || (currentQuestion.type === "previousyearquestions" && currentQuestion.year === "2024") || (currentQuestion.type === "previousyearquestions" && currentQuestion.year === "2023") || (currentQuestion.type === "previousyearquestions" && currentQuestion.year === "2022") || (currentQuestion.type === "previousyearquestions" && currentQuestion.year === "2021") ? (<>

                          {currentQuestion.question ? (
                            <p className="question-text">
                              {renderWithLatex(currentQuestion.question)}
                            </p>
                          ) : (
                            <QuestionImage
                              src={`/questionsPhoto/${currentQuestion.question_img}`}
                              alt="Question"
                            />
                          )}

                          <button onClick={handleToggle} style={{ fontSize: "8px", padding: "01px" }}>
                            {showContent ? "Hide source image" : "View source image"}
                          </button>
                          {showContent && (
                            <div style={{ padding: "5px" }}>
                              <QuestionImage
                                src={`/questionsPhoto/${currentQuestion.question_img}`}
                                alt="Question"
                              />
                            </div>
                          )}

                        </>) : (<>
                          {currentQuestion.question_img ? (
                            <QuestionImage
                              src={`/questionsPhoto/${currentQuestion.question_img}`}
                              alt="Question"
                            />
                          ) : (
                            <>{renderWithLatex(currentQuestion.question)}</>
                          )}
                        </>)}

                      </div>


                      <div className="options-section">
                        {currentQuestion && getCurrentOptions(currentQuestion).map((option, index) => (
                          <div key={index} className="option-item">
                            <label className="option-label">
                              <input
                                type="radio"
                                name="option"
                                value={`option${index + 1}`}
                                checked={selectedAnswers[currentQuestionIndex] === `option${index + 1}`}
                                onChange={handleOptionChange}
                                className="option-input"
                              />
                              <span className="option-letter">({String.fromCharCode(65 + index)})</span>
                              <span className="option-text">{renderWithLatex(option.label)}</span>
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="navigation-buttons">
                      <button
                        onClick={handlePreviousQuestion}
                        disabled={currentQuestionIndex === 0}
                        className="nav-button prev-button"
                      >
                        Previous
                      </button>
                      <button
                        onClick={toggleMarkQuestion}
                        className={`nav-button mark-button ${markedQuestions[currentQuestionIndex] ? 'marked' : ''}`}
                      >
                        {markedQuestions[currentQuestionIndex] ? "Unmark" : "Mark"}
                      </button>
                      {currentQuestionIndex < filterQuestions.length - 1 ? (
                        <button
                          onClick={handleNextQuestion}
                          className="nav-button next-button"
                        >
                          Next
                        </button>
                      ) : (
                        <button
                          onClick={() => customSubmitHandler(false)}
                          className="nav-button submit-button"
                        >
                          Submit
                        </button>
                      )}
                    </div>
                  </>
                  ) : (
                  <QuizReResults
                    score={score}
                    questions={filterQuestions}
                    quizId={quizId}
                  />
              )}
                </div>
            </div>
          </div>
          ) : (
          <div style={{ textAlign: 'center', margin: '2rem 0' }}>
            <QuizReStartScreen
              questions={filterQuestions}
              totalQuizTimeInSeconds={totalQuizTimeInSeconds}
              subjectName={quizName}
              handleStartQuiz={startQuiz}
            />

          </div>
      )}

          {/* Confirmation Modal */}
          {showConfirmModal && (
            <div style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 1000
            }}>
              <div style={{
                background: 'white',
                padding: '2rem',
                borderRadius: '8px',
                maxWidth: '400px',
                width: '90%',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
              }}>
                <h3>Confirm Submission</h3>
                <p>Are you sure you want to submit your answers and finish the exam?</p>
                <div style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: '1rem',
                  marginTop: '1.5rem'
                }}>
                  <button
                    onClick={handleCancelSubmit}
                    style={{
                      padding: '0.5rem 1rem',
                      border: 'none',
                      borderRadius: '4px',
                      background: '#cff305ff',
                      cursor: 'pointer'
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleConfirmSubmit}
                    style={{
                      padding: '0.5rem 1rem',
                      border: 'none',
                      borderRadius: '4px',
                      background: '#007bff',
                      color: 'white',
                      cursor: 'pointer'
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          )}
        </>
      );
}

      export default QuizReStarting;